import { create } from 'zustand';
import { persist } from 'zustand/middleware';

if (typeof window !== 'undefined') {
  localStorage.removeItem('gemini_api_key');
}

interface SettingsState {
  sidebarOpen: boolean;
  layersOpen: boolean;
  stylesOpen: boolean;
  settingsOpen: boolean;
  generationSettingsOpen: boolean;

  toggleSidebar: () => void;
  toggleLayers: () => void;
  toggleStyles: () => void;
  setSettingsOpen: (open: boolean) => void;
  setGenerationSettingsOpen: (open: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      layersOpen: true,
      stylesOpen: true,
      settingsOpen: false,
      generationSettingsOpen: false,

      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      toggleLayers: () => set((state) => ({ layersOpen: !state.layersOpen })),
      toggleStyles: () => set((state) => ({ stylesOpen: !state.stylesOpen })),
      setSettingsOpen: (settingsOpen) => set({ settingsOpen }),
      setGenerationSettingsOpen: (generationSettingsOpen) => set({ generationSettingsOpen }),
    }),
    {
      name: 'gemini-settings',
      partialize: (state) => ({
        sidebarOpen: state.sidebarOpen,
        layersOpen: state.layersOpen,
        stylesOpen: state.stylesOpen,
      }),
    }
  )
);
